export default "<div id=\"datacycle-map-widget\" class=\"map\" :style=\"mapStyle\">\n</div>";